import type { FormOptionType } from "@/components/ui/form/_types/type";

import * as Model from "../../../../model";

export const EC_RECEIPT_SEARCH_TYPE_OPTIONS: Array<FormOptionType> = [
	{
		id: Model.Constants.SearchTypeForECReceiptList.startDtAndEndDt,
		label: "購入日",
		value: Model.Constants.SearchTypeForECReceiptList.startDtAndEndDt,
	},
	{
		id: Model.Constants.SearchTypeForECReceiptList.receiptID,
		label: "レシートID",
		value: Model.Constants.SearchTypeForECReceiptList.receiptID,
	},
];
